/**
 * `{ instagram: { can_access_instagram: true }, pinterest: {…} }` →
 * `{ can_access_instagram: true, can_access_pinterest: true }`. `brand_roles` is not a permission
 * module and is dropped.
 *
 * Lives here rather than in `src/app/settings/utils.js` because `src/stores/auth.ts` needs it, and
 * 1255 dom specs reach that store — importing a settings module for a pure object transform put
 * the settings formatters and content-automation constants on all of their graphs.
 *
 * Typed loosely on purpose: callers pass generated permission shapes whose values are `unknown`,
 * and this was untyped JS until the move.
 */
export const flattenBrandUserPermissions = (permissions: Record<string, unknown> | undefined) => {
  const perms: Record<string, unknown> = {};
  Object.entries(permissions ?? {})
    .filter(([module]) => module !== 'brand_roles')
    .forEach(([, userModulePermissions]) => {
      Object.entries(userModulePermissions as Record<string, unknown>).forEach(
        ([permission, value]) => {
          perms[permission] = value;
        },
      );
    });
  return perms;
};
